// extracted by mini-css-extract-plugin
export default {"navWrapper":"OrgLayout_navWrapper__Y63ZE","isOpen":"OrgLayout_isOpen__mzuOw","coverWrapper":"OrgLayout_coverWrapper__PadUi"};